import { render, staticRenderFns } from "./SavingsCalculator.vue?vue&type=template&id=21043f7a&scoped=true&"
import script from "./SavingsCalculator.vue?vue&type=script&lang=js&"
export * from "./SavingsCalculator.vue?vue&type=script&lang=js&"
import style0 from "./SavingsCalculator.vue?vue&type=style&index=0&id=21043f7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21043f7a",
  null
  
)

export default component.exports